/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$(window).scroll(function() {

		var sticky = $('header'),
		scroll = $(window).scrollTop();

		if (scroll >= 200) sticky.addClass('fixed');
		else sticky.removeClass('fixed');



		var windowBottom = $(this).scrollTop() + $(this).innerHeight();
		
		
		$(".fade").each(function() {
		  /* Check the location of each desired element */
		  var objectBottom = $(this).offset().top + $(this).outerHeight();
		  
		  /* If the element is completely within bounds of the window, fade it in */
		  if ((objectBottom-400) < windowBottom) { 
			if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
		  }
		});


		$(".fade-last").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-200) < windowBottom) { 
			  if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
			}
		});

	  }).scroll();

	  // Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (
	location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	&& 
	location.hostname == this.hostname
  ) {
	// Figure out element to scroll to
	var target = $(this.hash);
	target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	// Does a scroll target exist?
	if (target.length) {
	  // Only prevent default if animation is actually gonna happen
	  event.preventDefault();
	  $('html, body').animate({
		scrollTop: target.offset().top
	  }, 1000, function() {
		// Callback after animation
		// Must change focus!
		var $target = $(target);
		$target.focus();
		if ($target.is(":focus")) { // Checking if the target was focused
		  return false;
		} else {
		  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
		  $target.focus(); // Set focus again
		};
	  });
	}
  }
});

$(".anim-line-1").addClass('open');
	

	new fullpage('#fullpage', {
		//options here
		autoScrolling:true,
		scrollHorizontally: true,
		verticalCentered: false,
	
		//to avoid problems with css3 transforms and fixed elements in Chrome, as detailed here: https://github.com/alvarotrigo/fullPage.js/issues/208
		css3:false,
		anchors: ['intro', 'present', 'vision', 'clients', 'impression', 'services', 'services-1', 'services-2', 'services-3', 'services-4', 'services-5', 'services-5', 'our-clients', 'get-in-touch'],
		menu: '.menu',
		// responsiveWidth: 800,
		onLeave: function(origin, destination, direction){
			var loadedSection = this;
	
		   // using anchorLink
			if(origin.anchor == 'present' || origin.anchor == 'clients'){
				document.querySelector(".blueline1").classList.add('open');
				document.querySelector(".blueline2").classList.add('open');
			}
	
			if(origin.anchor == 'vision'){
				document.querySelector(".blueline1").classList.add('open');
				document.querySelector(".blueline2").classList.add('open');
			}
	
			if(origin.anchor == 'vision' || origin.anchor == 'impression'){
				document.querySelector(".clientlist").classList.add('open');
			}
	
			if(origin.anchor == 'clients' || origin.anchor == 'services'){
				document.querySelector(".blueline3").classList.add('open');
				document.querySelector(".blueline4").classList.add('open');
			}
	
			if(origin.anchor == 'impression'){
				document.querySelector(".blueline3").classList.remove('open');
				document.querySelector(".blueline4").classList.remove('open');
			}
	
			if(origin.anchor == 'our-clients'){
				document.querySelector(".blueline5").classList.add('open');
				document.querySelector(".blueline6").classList.add('open');
			}
	
			if(origin.anchor == 'get-in-touch'){
				document.querySelector(".blueline5").classList.remove('open');
				document.querySelector(".blueline6").classList.remove('open');
			}
		}
	});
	
	//methods
	fullpage_api.setAllowScrolling(true);
	
	
	

	$('.nextslide').on('click', function() {
		fullpage_api.moveSectionDown();
		});
		$('.prevslide').on('click', function() {
			fullpage_api.moveSectionUp();
		});


	 
});
